import type { Vector3Tuple } from "three";

/**
 * Layout for the landing hero diorama. Positions mirror the in-app world
 * (dioramaLayout.ts) so the marketing scene is an honest preview of the
 * product, but labels and captions come from the `home` i18n namespace.
 */
export type HeroObjectId =
  | "mailbox"
  | "computer"
  | "fileCabinet"
  | "telephone"
  | "calendar"
  | "sleepPatch";

export type HeroPropId = HeroObjectId | "clawbert";

export interface HeroPropEntry {
  id: HeroObjectId;
  position: Vector3Tuple;
}

export const HERO_PROPS: HeroPropEntry[] = [
  { id: "computer", position: [0, 0, 3] },
  { id: "telephone", position: [-4.5, 0, 0] },
  { id: "fileCabinet", position: [3.5, 0, -3] },
  { id: "calendar", position: [-3.5, 0, -3.5] },
  { id: "mailbox", position: [4.5, 0, 1.5] },
  { id: "sleepPatch", position: [-2.5, 0, 3.5] },
];

/** Chips shown under the world as the plain, accessible path to the same info. */
export const HERO_CHIP_IDS: HeroObjectId[] = [
  "mailbox",
  "computer",
  "fileCabinet",
  "telephone",
  "calendar",
];
